import { Button, FlexBox, Heading, Icon, Label, Modal, ModalBody, ModalFooter, ModalHeading, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from "@braze/beacon-core"
import { RoundedCard } from "../../shared/RoundedCard"
import { CampaignObject } from '../../types/APITypes';
import styled from "styled-components";
import { useState } from "react";
import { Select } from "@braze/beacon-lab-select";
import { formatOption } from "../../util/optionsFormatter";
import { useGlobalAppContext } from "../../contexts/GlobalAppContext";
import { useDeleteCampaignOverview } from "../../hooks/useDeleteCampaignOverview";

export const DeleteCampaigns = () => {

    const { campaigns, setRefresh } = useGlobalAppContext();
    const [open, setOpen] = useState(false);
    const [currentCampaign, setCurrentCampaign] = useState<CampaignObject>({} as CampaignObject);
    const [deleteCampaign, deleteCampaignResponse] = useDeleteCampaignOverview()

    const campaign_options = campaigns !== null ? formatOption(campaigns.map(c => c.campaign_name_final != null ? c.campaign_name_final : c.campaign_name)) : [];

    const selectCampaign = (camp : string|null) => {

        if (camp != null) {
            let selected:CampaignObject[] = campaigns?.filter(c => camp === (c.campaign_name_final !== null ? c.campaign_name_final : c.campaign_name))
            setCurrentCampaign(selected[0]);
            toggleModal();
        }
    }
    const toggleModal = () => {
        setOpen(!open);
    }
    const deleteClick = (c:CampaignObject) => {
        setCurrentCampaign(c);
        toggleModal();
    }

    return (
        <>
            <FlexBox direction="column">
                <Modal isOpen={open} toggle={toggleModal} size="lg">
                    <ModalHeading>
                        Are you sure you want to delete this campaign?
                    </ModalHeading>
                    <ModalBody>
                        {currentCampaign?.campaign_name_final != null ? currentCampaign?.campaign_name_final : currentCampaign?.campaign_name}
                    </ModalBody>
                    <ModalFooter>
                        <Button 
                            intent="danger" 
                            onClick={() => 
                                deleteCampaign(currentCampaign)
                                .then(r => {
                                    setRefresh(true);
                                    toggleModal();
                                })}>
                                Delete Campaign
                        </Button>
                    </ModalFooter>
                </Modal>
                <RoundedCard>
                    <Heading level={2}>Delete Campaigns From Overview</Heading>
                    
                    <FlexBox style={{alignItems: "center", marginTop: "3rem", marginBottom: "3rem"}}>
                        <Label style={{marginRight: "2rem"}}>Search:</Label>
                        <Select 
                            options={campaign_options} 
                            fluid 
                            onChange={(selectedOption: any) => {
                                console.log(selectedOption)
                                if (selectedOption !== null) {selectCampaign(selectedOption["label"]);}
                            }}
                        />
                    </FlexBox>

                    <FlexBox direction="column">
                        <Table>
                            <TableHeader>
                                <TableHeaderCell>Campaign</TableHeaderCell>
                                <TableHeaderCell>Status</TableHeaderCell>
                                <TableHeaderCell>Delete?</TableHeaderCell>
                            </TableHeader>
                            <TableBody>
                                {campaigns
                                    .filter((c : CampaignObject) => c["approval_status"] !== "Deleted" && c["approval_status"] !== "Launched")
                                    .map((c:CampaignObject) => {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell>{c.campaign_name_final != null ? c.campaign_name_final : c.campaign_name}</TableCell>
                                                    <TableCell>{c.approval_status}</TableCell>
                                                    <TableCell style={{borderBottom: "0px"}}>
                                                        <StyledIcon name={"x"} onClick={() => {deleteClick(c)}}/>
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        )
                                })}
                            </TableBody>
                        </Table>
                    </FlexBox>         
                </RoundedCard>
            </FlexBox>
        </>
    )

}


const StyledIcon = styled(Icon)`
    width: 100%;    
    .svg-inline--fa {
        border-bottom: 0px !important;
    }
    cursor: pointer;
    border-bottom: 0px !important;
`